import {
  createContractStatus,
  clearContractStatusErrors,
  clearContractStatusAction,
} from 'actions/contracts/contractStatusActions'
import AdminForm from 'components/admin/AdminForm'
import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const ContractStatusCreate = ({ formId, params, setParams, closeModal }) => {
  //// HOOKS.
  const dispatch = useDispatch()

  //// GLOBAL STATE.
  const { lastAction, statusErrors } = useSelector(
    (state) => state.contractStatuses
  )

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.
  useEffect(() => {
    return () => {
      dispatch(clearContractStatusErrors())
      dispatch(clearContractStatusAction())
    }
  }, [dispatch])

  useEffect(() => {
    if (_.isEmpty(params)) {
      setParams({
        name: '',
      })
    }
  }, [params, setParams])

  useEffect(() => {
    if (lastAction === 'create') {
      closeModal()
    }
  }, [lastAction, closeModal])

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return !_.size(params) ? (
    ''
  ) : (
    <form
      id={formId}
      onSubmit={(e) => {
        e.preventDefault()

        dispatch(createContractStatus(params))
      }}
      className="form container"
      noValidate
    >
      <AdminForm params={params} setParams={setParams} errors={statusErrors} />
    </form>
  )
}

export default ContractStatusCreate
